import actions from './actions.js'
import getters from './getters.js'
import {state, mutations} from './loginUserMutation.js'

export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}



// WEBPACK FOOTER //
// ./src/store/modules/loginUserModules/loginUserModule.js